// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/javascripts/single_work/index.js
// modified with global simulating transforms: post
// MAGIC_DESPROCKET_END
/* eslint-disable
    prettier/prettier,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import $ from 'jquery';
class PreviewController {
  constructor() {
    this.views = {};
    this.current_identifier = null;
  }

  show(identifier) {
    if (this.current_identifier) {
      this._hide_view(this.current_identifier);
    }
    this.current_identifier = identifier;
    return this._show_view(identifier);
  }

  register_view(identifier, view) {
    if (this.views[identifier] != null) {
      throw "Can't register multiple views for the same identifier!";
    } else {
      this.views[identifier] = view;
      if (this.current_identifier === identifier) {
        return this._show_view(identifier);
      }
    }
  }

  _show_view(identifier) {
    this._view_container(identifier).show();
    return __guardMethod__(this.views[identifier], 'show', (o) => o.show());
  }

  _hide_view(identifier) {
    __guardMethod__(this.views[identifier], 'tear_down', (o) => o.tear_down());
    return this._view_container(identifier).hide();
  }

  _view_container(identifier) {
    return $('.attachment_preview[data-attachment=' + identifier + ']');
  }
}


function __guardMethod__(obj, methodName, transform) {
  if (typeof obj !== 'undefined' && obj !== null && typeof obj[methodName] === 'function') {
    return transform(obj, methodName);
  } else {
    return undefined;
  }
}

if (window.SingleWork) {
  window.SingleWork.PreviewController = PreviewController
  window.SingleWork.preview_controller = new PreviewController();
}

export default PreviewController;
// MAGIC_DESPROCKET_START
window.PreviewController = PreviewController;
window.__guardMethod__ = __guardMethod__;
// MAGIC_DESPROCKET_END
